// extracted by mini-css-extract-plugin
module.exports = {"Root":"expired_Root__yR-zn","Button":"expired_Button__23Lvk","Link":"expired_Link__3sWtT"};